__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-09-1770621839-stable-dev/";